import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, timeout } from 'rxjs/operators';
import { environment } from '../../../../../../apps/piqet-angular/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  apiUrl = environment.url;
  constructor(private http: HttpClient) {}

  getIPAddress(): Observable<string | null> {
    return this.http.get<any>('https://api.ipify.org?format=json').pipe(
      timeout(5000),
      map((res: any) => res?.ip ?? null),
      catchError(() =>
        this.http.get<any>('https://api64.ipify.org?format=json').pipe(
          timeout(5000),
          map((res: any) => res?.ip ?? null),
          catchError(() => of(null))
        )
      )
    );
  }

  login(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Login/LoginUser`, payload);
  }

  CheckUserSession(payload: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Login/CheckUserSession?userId=${payload.userId}&sessionId=${payload.sessionId}`
    );
  }

  forgotPassword(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Login/ForgotPassword`, payload);
  }

  changePassword(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Login/ChangePassword`, payload);
  }

  resetPassword(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Login/ResetPassword`, payload);
  }

  activeUser(payload: any) {
    return this.http.get<any>(`${this.apiUrl}/User/ActivateUser?activationCode=${payload}`, {});
  }

  activateByTrialCode(payload: any) {
    return this.http.get<any>(`${this.apiUrl}/User/VerifyTempRegistration?token=${payload}`, {});
  }

  activateByUID(payload: any) {
    return this.http.get<any>(`${this.apiUrl}/User/ActivateUserByUID?uid=${payload}`, {});
  }

  register(payload: any, purchaseType: string) {
    return this.http.post<any>(`${this.apiUrl}/User/TrialVersion?submit=${purchaseType}`, payload);
  }
  verifyOtp(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/Login/VerifyOtp?OTP=${payload.otp}&UserId=${payload.userId}&ipAddress=${payload.ipAddress}`,
      {}
    );
  }
  resendOtp(userId: any) {
    return this.http.get<any>(`${this.apiUrl}/Login/ResendOTP?user=${userId}`);
  }
  CheckOrganization(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/User/CheckOrganization`, payload).toPromise();
  }

  thanks(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/User/Thanks`, payload);
  }

  checkOrganizationSSOLogin(orgName: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Login/checkOrganizationSSOLogin?OrganizationName=${orgName}`
    );
  }

  accessRoles() {
    return this.http.get<any>(`${this.apiUrl}/Login/AccessToModule`).toPromise();
  }

  logout(userId: any, deviceId?: string, ipAddress?: string) {
    let url = `${this.apiUrl}/Login/LogoutUser`;

    if (deviceId) {
      url += `/${deviceId}`;
      if (ipAddress) {
        url += `/${ipAddress}`;
      }
    }
    return this.http.get<any>(url);
  }
  refreshToken(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Login/RefreshToken`, payload);
  }
}
